import React, { useMemo } from "react";

// external libs

import { Navigate } from "react-router-dom";

// common

import { configs } from "../../constants/configs/configs";

interface PrivateRouteProps {
    path: string;
    isAllowed: boolean;
    redirectPath?: string;
    element: any;
}

function PrivateRoute(props: PrivateRouteProps) {
    const { element, isAllowed, path, redirectPath, ...rest } = props;

    const { FALLBACK } = configs.routes;

    const Element = useMemo(() => {
        return isAllowed ? element : <Navigate to={redirectPath || FALLBACK} replace />;
    }, [isAllowed, redirectPath, FALLBACK, element]);

    // return jsx element Element = <Element/>
    return Element;
}



export default PrivateRoute;
